<template>

    <v-container class="fill-height data-container" fluid>

        <h2 class="mt-0 mb-2" v-text="`${$props.commonObject.object_name} - Fields`" />

        <div id="ag-grid-common-object-fields-container">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                :gridOptions="gridOptions"
                @row-double-clicked="(params) => editField(params.data)"
                :groupHeaders="true"
                :rowHeight="40">
            </ag-grid-vue>
        </div>
        <v-btn color="#c42111" class="mt-3 mr-9" @click="addNewFieldClick" :disabled="$props.lockSave" v-if="showGrid">New</v-btn>
        <v-btn color="#c42111" class="mt-3 mr-3" @click="$emit('save')" :disabled="lockSave" v-if="showGrid">Save</v-btn>
        <v-btn color="#c42111" class="mt-3 mr-3" @click="$emit('back')" v-if="showGrid">Back</v-btn>

        <v-dialog v-model="showFieldEdit" max-width="80%" width="300px" persistent @keydown="(k) => {k.key == 'Escape' ? showFieldEdit = false : null}">
            <field-edit :field="selectedFieldClone" v-if="showFieldEdit" @ok="applyFieldChanges" @cancel="cancelFieldChanges"></field-edit>
        </v-dialog>
    
    </v-container>

</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import FieldEdit from "@/components/CommonObjects/FieldEdit";
export default {
    name: 'FieldsList',
    props: ['fieldsList', 'commonObject', 'lockSave'],
    components: {
        'ag-grid-vue': AgGridVue,
        FieldEdit
    },
    data: () => ({
        showGrid: false,
        selectedField: null,
        selectedFieldClone: null,
        newField: false,
        showFieldEdit: false
    }),

    computed: {

    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.$props.fieldsList;
            this.gridOptions.columnDefs = this.createColumnDefs();

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport'
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 160, 
                    filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.isTop = params.data.field_order == 1;
                            this.isBottom = params.data.field_order == self.$props.fieldsList.length;

                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle field-list-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle field-list-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span title="Edit Fields" class="mdi mdi-arrow-up-circle field-list-action" style="cursor: ${this.isTop ? 'default' : 'pointer'}; color: ${this.isTop ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span title="Edit Items" class="mdi mdi-arrow-down-circle field-list-action" style="cursor: ${this.isBottom ? 'default' : 'pointer'}; color: ${this.isBottom ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);
                            this.moveUpButtonHandler = this.moveUpButtonHandler.bind(this);
                            this.moveDownButtonHandler = this.moveDownButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.field-list-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.field-list-action')[1];
                            this.moveUpButton = this.eGui.querySelectorAll('.field-list-action')[2];
                            this.moveDownButton = this.eGui.querySelectorAll('.field-list-action')[3];

                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                            this.moveUpButton.addEventListener('click', this.moveUpButtonHandler);
                            this.moveDownButton.addEventListener('click', this.moveDownButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        moveUpButtonHandler(event) {
                            event.stopPropagation();
                            this.params.moveUpFunction(this.params, this.isTop);
                        }
                        moveDownButtonHandler(event) {
                            event.stopPropagation();
                            this.params.moveDownFunction(this.params, this.isBottom);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                            this.moveUpButton.removeEventListener('click', this.moveUpButtonHandler);
                            this.moveDownButton.removeEventListener('click', this.moveDownButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            if(!self.lockSave) {
                                this.editField(params.data);
                            }
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deleteField(params.data);
                            }
                        },
                        moveUpFunction: (params, isTop) => {
                            if(!isTop) {
                                this.moveUp(params.data);
                            }
                        },
                        moveDownFunction: (params, isBottom) => {
                            if(!isBottom) {
                                this.moveDown(params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Order', 
                    field: 'field_order', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Field Name', 
                    field: 'field_name', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Description', 
                    field: 'field_description', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Line Height', 
                    field: 'field_line_height', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
            ];
            return columnDefs;
        },

        moveUp: function(field) {
            this.swapFields(this.$props.fieldsList.indexOf(field), (this.$props.fieldsList.indexOf(field) - 1));
        },

        moveDown: function(field) {
            this.swapFields(this.$props.fieldsList.indexOf(field), (this.$props.fieldsList.indexOf(field) + 1));
        },

        swapFields: function(idx1, idx2) {
            let temp = this.$props.fieldsList[idx1];
            this.$props.fieldsList[idx1] = this.$props.fieldsList[idx2];
            this.$props.fieldsList[idx2] = temp;
            for(const [idx, f] of this.$props.fieldsList.entries()) {
                f.field_order = (idx + 1);
            }
            this.gridOptions.api.setRowData(this.$props.fieldsList);
        },

        addNewFieldClick: function() {
            this.selectedFieldClone = {
                field_description: "",
                field_id: 0,
                field_line_height: 1,
                field_name: "",
                field_order: this.$props.fieldsList.length + 1,
                object_id: this.$props.commonObject.object_id
            };
            this.newField = true;
            this.showFieldEdit = true;
        },

        editField: function(field) {
            if(this.lockSave) {
                return;
            }
            this.selectedField = field;
            this.selectedFieldClone = JSON.parse(JSON.stringify(field));
            this.showFieldEdit = true;
        },

        deleteField: function(field) {
            this.$props.fieldsList.splice(this.$props.fieldsList.indexOf(field), 1);
            // Since we deleted one we now need to recalculate the order for the rest.
            for(const [idx, f] of this.$props.fieldsList.entries()) {
                f.field_order = (idx + 1);
            }
            this.gridOptions.api.setRowData(this.$props.fieldsList);
        },

        applyFieldChanges: function() {
            if(this.newField) {
                this.$props.fieldsList.push(this.selectedFieldClone);
            }
            else {
                this.$props.fieldsList[this.$props.fieldsList.indexOf(this.selectedField)] = this.selectedFieldClone;
                this.$props.fieldsList.splice(0,0); // trigger watch to refresh agGrid
            }
            this.showFieldEdit = false;
            this.selectedField = null;
            this.selectedFieldClone = null;
            this.newField = false;
        },

        cancelFieldChanges: function() {
            this.showFieldEdit = false; 
            this.selectedField = null;
            this.selectedFieldClone = null;
            this.newField = false;
        }

    },

    watch: {
        fieldsList: {
            handler(newVal, oldVal) {
                if(!this.$props.lockSave) {
                    this.$store.commit('setIsDirty', true);
                }
                this.gridOptions.api.setRowData(this.$props.fieldsList);
            },
            deep: true
        }
    },

    mounted() {
        this.buildAgGrid();
    }

  
};
</script>

<style scoped>

    .data-container {
        display: block;
        padding: 0;
    }

    #ag-grid-common-object-fields-container {
        height: calc(100vh - 170px);
        width: 100%;
    }

</style>
